import { EventEmitter, Component, ElementRef, NgZone, Input, Output, NgModule } from '@angular/core';
import { dispatchEditorEvents, appendEditor, openEditor, overlayEditor } from 'doka';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
class DokaImageEditorAbstractComponent {
    constructor(element, zone) {
        this.unsubs = [];
        this.src = undefined;
        this.options = undefined;
        this.loadstart = new EventEmitter();
        this.loaderror = new EventEmitter();
        this.loadprogress = new EventEmitter();
        this.load = new EventEmitter();
        this.processstart = new EventEmitter();
        this.processerror = new EventEmitter();
        this.processprogress = new EventEmitter();
        this.process = new EventEmitter();
        this.undo = new EventEmitter();
        this.redo = new EventEmitter();
        this.revert = new EventEmitter();
        this.destroy = new EventEmitter();
        this.show = new EventEmitter();
        this.hide = new EventEmitter();
        this.close = new EventEmitter();
        this.routeEvent = (e) => {
            const emitter = this[e.type.split(':')[1]];
            if (!emitter)
                return;
            emitter.emit(e.detail);
        };
        this.element = element;
        this.zone = zone;
    }
    initEditor(element, props) {
        return undefined;
    }
    ngAfterViewInit() {
        this.element.nativeElement.classList.add('DokaRootWrapper');
        // will block angular from listening to events inside doka
        this.zone.runOutsideAngular(() => {
            this.editor = this.initEditor(this.element.nativeElement, Object.assign({}, this.options, { src: this.src }));
            this.unsubs = dispatchEditorEvents(this.editor, this.element.nativeElement);
        });
        // route events
        Object.keys(this)
            .filter((key) => this[key] instanceof EventEmitter)
            .forEach((key) => {
            this.element.nativeElement.addEventListener(`doka:${key}`, this.routeEvent);
        });
    }
    ngOnChanges() {
        if (!this.editor)
            return;
        Object.assign(this.editor, this.options, { src: this.src });
    }
    ngOnDestroy() {
        if (!this.editor)
            return;
        this.editor.destroy();
        // unsubscribe
        this.unsubs.forEach((unsub) => unsub());
        this.unsubs = [];
        // unroute events
        Object.keys(this)
            .filter((key) => this[key] instanceof EventEmitter)
            .forEach((key) => {
            this.element.nativeElement.removeEventListener(`doka:${key}`, this.routeEvent);
        });
        this.editor = undefined;
    }
    ngOnInit() { }
}
DokaImageEditorAbstractComponent.ɵfac = function DokaImageEditorAbstractComponent_Factory(t) { return new (t || DokaImageEditorAbstractComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
DokaImageEditorAbstractComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DokaImageEditorAbstractComponent, selectors: [["doka-image-editor"]], inputs: { src: "src", options: "options" }, outputs: { loadstart: "loadstart", loaderror: "loaderror", loadprogress: "loadprogress", load: "load", processstart: "processstart", processerror: "processerror", processprogress: "processprogress", process: "process", undo: "undo", redo: "redo", revert: "revert", destroy: "destroy", show: "show", hide: "hide", close: "close" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0, decls: 1, vars: 0, template: function DokaImageEditorAbstractComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
DokaImageEditorAbstractComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
DokaImageEditorAbstractComponent.propDecorators = {
    src: [{ type: Input }],
    options: [{ type: Input }],
    loadstart: [{ type: Output }],
    loaderror: [{ type: Output }],
    loadprogress: [{ type: Output }],
    load: [{ type: Output }],
    processstart: [{ type: Output }],
    processerror: [{ type: Output }],
    processprogress: [{ type: Output }],
    process: [{ type: Output }],
    undo: [{ type: Output }],
    redo: [{ type: Output }],
    revert: [{ type: Output }],
    destroy: [{ type: Output }],
    show: [{ type: Output }],
    hide: [{ type: Output }],
    close: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DokaImageEditorAbstractComponent, [{
        type: Component,
        args: [{
                selector: 'doka-image-editor',
                template: ` <ng-content></ng-content> `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { src: [{
            type: Input
        }], options: [{
            type: Input
        }], loadstart: [{
            type: Output
        }], loaderror: [{
            type: Output
        }], loadprogress: [{
            type: Output
        }], load: [{
            type: Output
        }], processstart: [{
            type: Output
        }], processerror: [{
            type: Output
        }], processprogress: [{
            type: Output
        }], process: [{
            type: Output
        }], undo: [{
            type: Output
        }], redo: [{
            type: Output
        }], revert: [{
            type: Output
        }], destroy: [{
            type: Output
        }], show: [{
            type: Output
        }], hide: [{
            type: Output
        }], close: [{
            type: Output
        }] }); })();

class DokaImageEditorComponent extends DokaImageEditorAbstractComponent {
    initEditor(element, props) {
        return appendEditor(element, props);
    }
}
DokaImageEditorComponent.ɵfac = function DokaImageEditorComponent_Factory(t) { return ɵDokaImageEditorComponent_BaseFactory(t || DokaImageEditorComponent); };
DokaImageEditorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DokaImageEditorComponent, selectors: [["doka-image-editor"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 1, vars: 0, template: function DokaImageEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
const ɵDokaImageEditorComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DokaImageEditorComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DokaImageEditorComponent, [{
        type: Component,
        args: [{
                selector: 'doka-image-editor',
                template: ` <ng-content></ng-content> `
            }]
    }], null, null); })();

class DokaImageEditorModalComponent extends DokaImageEditorAbstractComponent {
    initEditor(element, props) {
        return openEditor(props);
    }
    showEditor() {
        this.editor.show();
    }
    hideEditor() {
        this.editor.hide();
    }
    ngOnDestroy() {
        if (!this.editor)
            return;
        this.editor = undefined;
    }
}
DokaImageEditorModalComponent.ɵfac = function DokaImageEditorModalComponent_Factory(t) { return ɵDokaImageEditorModalComponent_BaseFactory(t || DokaImageEditorModalComponent); };
DokaImageEditorModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DokaImageEditorModalComponent, selectors: [["doka-image-editor-modal"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 1, vars: 0, template: function DokaImageEditorModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
const ɵDokaImageEditorModalComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DokaImageEditorModalComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DokaImageEditorModalComponent, [{
        type: Component,
        args: [{
                selector: 'doka-image-editor-modal',
                template: ` <ng-content></ng-content> `
            }]
    }], null, null); })();

class DokaImageEditorOverlayComponent extends DokaImageEditorAbstractComponent {
    initEditor(element, props) {
        return overlayEditor(element, props);
    }
}
DokaImageEditorOverlayComponent.ɵfac = function DokaImageEditorOverlayComponent_Factory(t) { return ɵDokaImageEditorOverlayComponent_BaseFactory(t || DokaImageEditorOverlayComponent); };
DokaImageEditorOverlayComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DokaImageEditorOverlayComponent, selectors: [["doka-image-editor-overlay"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 1, vars: 0, template: function DokaImageEditorOverlayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
const ɵDokaImageEditorOverlayComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DokaImageEditorOverlayComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DokaImageEditorOverlayComponent, [{
        type: Component,
        args: [{
                selector: 'doka-image-editor-overlay',
                template: ` <ng-content></ng-content> `
            }]
    }], null, null); })();

class AngularDokaModule {
}
AngularDokaModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AngularDokaModule });
AngularDokaModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AngularDokaModule_Factory(t) { return new (t || AngularDokaModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AngularDokaModule, { declarations: [DokaImageEditorComponent, DokaImageEditorModalComponent, DokaImageEditorOverlayComponent], exports: [DokaImageEditorComponent, DokaImageEditorModalComponent, DokaImageEditorOverlayComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AngularDokaModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DokaImageEditorComponent,
                    DokaImageEditorModalComponent,
                    DokaImageEditorOverlayComponent,
                ],
                imports: [],
                exports: [
                    DokaImageEditorComponent,
                    DokaImageEditorModalComponent,
                    DokaImageEditorOverlayComponent,
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of angular-doka
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AngularDokaModule, DokaImageEditorComponent, DokaImageEditorModalComponent, DokaImageEditorOverlayComponent, DokaImageEditorAbstractComponent as ɵa };

//# sourceMappingURL=angular-doka.js.map